import { AREA_CHART_BASE_OPTIONS } from "./AreaChart.constants";
import { deepmerge } from "@commonlibs";
import clsx from "clsx";
import { AreaChartProps } from "./AreaChart.types";
import { useMemo } from "react";
import { AreaChartRoot } from "./AreaChart.styles";
import "../ChartJs";
import { Skeleton } from "@commonlibs";
import { Line as LineChart } from "react-chartjs-2";

function AreaChart({ className, options = {}, isLoading, ...rest }: AreaChartProps) {
    const finalOptions = useMemo(() => deepmerge(AREA_CHART_BASE_OPTIONS, options), [options]);
    return (
        <Skeleton loading={isLoading}>
            {/*Do not remove this Root or the chart will be hidden after a route change. */}
            <AreaChartRoot>
                <LineChart className={clsx("area-chart", className)} data-testid="LineChart" options={finalOptions} {...rest} />
            </AreaChartRoot>
        </Skeleton>
    );
}

export default AreaChart;
